import React, { FC } from 'react';
import { Styled } from './index.styles';
import { useCheckBreakpoint } from '../../hooks';
import clsx from 'clsx';
import { useConditionalHQVContext } from '../../hooks/lib/useConditionalHQVContext';
import { useConditionalPageContextSERP, useConditionalServerDataHotelInformationSERP } from '../../hooks';
import { PET_POLICY_FEE_TYPE_PER_NIGHT } from '../../constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HotelPetPolicy: FC<{ hotelInformationData: any }> = ({ hotelInformationData }) => {
  const { jsonContent } = useConditionalServerDataHotelInformationSERP();
  // Read HQV state via the flag-aware hook. When rendered inside the HQV modal, the parent
  // wraps children with HQVModalFlagContext ('serp' or 'adf') so this call picks up the correct
  // store (Zustand when the page's *_ZUSTAND flag is on, React Context otherwise).
  const { hqvState } = useConditionalHQVContext();
  const { pageVal } = useConditionalPageContextSERP();
  const policyInfo = hotelInformationData?.property?.policies;
  const petsAllowedFlag = policyInfo?.petsAllowed;
  const petsNotAllowedText = jsonContent?.petsNotAllowedLabel;
  const petsAllowedSearchText = jsonContent?.petsAllowedSearchText;
  const petsText = petsAllowedFlag ? petsAllowedSearchText : petsNotAllowedText;
  const petsPolicyDescription =
    policyInfo?.localizedPetsPolicyDescription?.translatedText ?? policyInfo?.petsPolicyDescription;
  const isViewportL = useCheckBreakpoint('viewportL');
  const isViewportM = useCheckBreakpoint('viewportM');

  return (
    <Styled>
      <div className="pet-policy">
        <div className={clsx('col', 'm-icon-text', 'section-heading', `${hqvState.modalOpenState ? 'hqv-modal' : ''}`)}>
          {pageVal !== 'chat' && (
            <span
              className={clsx(
                isViewportL ? 'icon-m icon-decorative left-col-icon' : 'icon-s icon-decorative left-col-icon',
                'check-out',
                'pet-policy-icon',
                'icon-pet-friendly'
              )}
            ></span>
          )}
          <span
            className={clsx(
              pageVal === 'chat'
                ? 't-subtitle-s pet-policy-heading-chat'
                : isViewportM
                ? 't-subtitle-l'
                : 't-subtitle-m',
              'pet-policy-heading'
            )}
          >
            {jsonContent?.petPolicyLabel}
          </span>
        </div>
        <div
          className={clsx(
            pageVal === 'chat' ? 't-font-s pl-0' : isViewportL ? 't-font-s' : 't-font-xs',
            pageVal === 'chat' ? '' : 'pet-policy-information'
          )}
        >
          {petsText}
        </div>
        {petsAllowedFlag && (
          <>
            {policyInfo?.petsPolicyDetails[0]?.maximumPetsDesc && (
              <div
                className={clsx(
                  pageVal === 'chat' ? 't-font-s pl-0' : isViewportL ? 't-font-s' : 't-font-xs',
                  'pet-policy-sub-info'
                )}
              >
                {policyInfo?.petsPolicyDetails?.maximumPetsDesc}
              </div>
            )}
            {petsPolicyDescription && (
              <div
                className={clsx(
                  pageVal === 'chat' ? 't-font-s pl-0' : isViewportL ? 't-font-s' : 't-font-xs',
                  'pet-policy-sub-info'
                )}
              >
                {petsPolicyDescription}
              </div>
            )}
            {policyInfo?.petsPolicyDetails?.length > 0 && policyInfo?.petsPolicyDetails[0]?.nonRefundableFee && (
              <div
                className={clsx(
                  pageVal === 'chat' ? 't-font-s pl-0' : isViewportL ? 't-font-s' : 't-font-xs',
                  'pet-policy-sub-info'
                )}
              >
                {jsonContent?.nonRefundableFeeLabel}: {policyInfo?.petsPolicyDetails[0]?.nonRefundableFee}{' '}
                {policyInfo?.petsPolicyDetails[0]?.nonRefundableFeeType === PET_POLICY_FEE_TYPE_PER_NIGHT &&
                jsonContent?.perNightLabel
                  ? jsonContent?.perNightLabel
                  : jsonContent?.perStayLabel}
              </div>
            )}
            {petsAllowedFlag && (
              <div
                className={clsx(
                  pageVal === 'chat' ? 't-font-s pl-0' : isViewportL ? 't-font-s' : 't-font-xs',
                  'pet-policy-sub-info'
                )}
              >
                {jsonContent?.contactHotelLabel}
              </div>
            )}
          </>
        )}
      </div>
    </Styled>
  );
};
